import {Pipe, PipeTransform} from '@angular/core';

/**
 * Converts a minor denomination amount to major denomination.
 * The minor denomination is divided by 100.
 */
@Pipe({
    name: 'toMajor',
    standalone: false
})
export class ToMajorPipe implements PipeTransform
{
    transform(value: any, ...args): any
    {
        const minorValue = parseInt(value, 10);
        return minorValue / 100;
    }
}